import type {SketchSplineObject} from '../sketch/SketchSplineObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图样条对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图样条协议时返回 true。
 */
export function isSketchSplineObject(value: unknown): value is SketchSplineObject {
	// 使用样条对象的运行时标记执行判定。
	return hasRuntimeFlag(value, 'isSketchSplineObject');
}
